import {Component, ContentChildren, Input, OnInit, QueryList} from '@angular/core';
import {LiveDataGraphComponent} from './live-data-graph.component';

/**
 * This class is a wrapper around actual ghaph implementation to do wrapper tasks.
 * @arnab.chakraborty@pathcom.com
 */
@Component({
  selector: 'app-live-data-view',
  templateUrl: './live-data-view.component.html',
  styleUrls: ['./live-data-view.component.css']
})
export class LiveDataViewComponent implements OnInit {
  @ContentChildren(LiveDataGraphComponent)
  graphComponentQueryList: QueryList<LiveDataGraphComponent>;
  private _graphs: Array<LiveDataGraphComponent> = [];

  constructor() {
  }

  ngOnInit() {

  }

}
